<template>
  <div
    class="m-market-navs"
    :class="{
      sticky: fixedValue !== false,
      'has-more': hasMore
    }"
    :style="{
      top: fixedValue !== false ? fixedValue + 'px' : 0
    }"
  >
    <VSnapNav
      v-if="marketList.length"
      ref="snapNav"
      :value="value"
      class="m-sub-navs"
      :force-bar-width="20"
      @change="onChangeNav"
    >
      <VSnapNavItem
        v-for="item in marketList"
        :key="item.id"
        class="m-sub-nav-item"
        :name="item.id"
      >
        {{ item.name }}
      </VSnapNavItem>

      <VSnapNavItem
        v-if="tempMarket"
        :key="tempMarket.id"
        class="m-sub-nav-item"
        :name="tempMarket.id"
      >
        {{ tempMarket.name }}
      </VSnapNavItem>
    </VSnapNav>
    <template v-if="hasMore">
      <div
        class="m-more"
        @click="showMarketBar"
      >
        <img
          src="../../common/images/icon-market-navs-more.svg"
          width="12px"
          height="12px"
        />
      </div>
      <VPopup
        v-model="marketVisible"
        class="m-popup"
        type="popup-right"
        @close="hideMarketBar"
      >
        <keep-alive>
          <MarketBar
            v-if="marketVisible"
            :market-id="value"
            :expanded="expanded"
            :market-group-list="marketGroupList"
            :markets-map="marketsMap"
            @change="onChangeMarketBar"
          />
        </keep-alive>
      </VPopup>
    </template>
  </div>
</template>

<script>
/* 默认 market nav list */
import VSnapNav from 'fe-vui/snapNav'
import VSnapNavItem from 'fe-vui/snapNavItem'
import VPopup from 'fe-vui/popup'
import getFixed, { resetElFixed } from 'wap/directive/fixed'
import modalHelper from '@ms/utils/scroll-fixed'

export default {
  name: 'MarketNavs',
  components: {
    VSnapNav,
    VSnapNavItem,
    VPopup,
    MarketBar: () => import(/* webpackPrefetch: true, webpackChunkName: 'aside-markets' */ './MarketBar')
  },
  directives: {
    fixed: getFixed()
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    hasMore: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    marketList: {
      type: Array,
      default: () => []
    },
    marketGroupList: {
      type: Array,
      default: () => []
    },
    marketsMap: {
      type: Object,
      default: () => ({})
    },
    fixedValue: {
      type: [Number, Boolean],
      default: 0
    },
    // 是否默认展开
    expanded: {
      type: Boolean,
      default: false
    },
    // 埋点 key
    dataLabel: {
      type: String,
      default: 'MatchList_MoreMarkets'
    }
  },
  data() {
    return {
      marketVisible: false,
      // 临时 market 导航
      tempMarket: null
    }
  },
  created() {
    this.hasMore && this.updateTempMarket()
  },
  activated() {
    if (this.fixedValue !== false) {
      if (document.scrollingElement.scrollTop === 0) {
        resetElFixed(this.$el)
      }
    }
  },
  deactivated() {
    this.reset()
  },
  beforeDestroy() {
    this.reset()
  },
  methods: {
    reset() {
      if (this.marketVisible) {
        modalHelper.beforeClose()
        this.marketVisible = false
      }
    },
    onChangeNav(id, name) {
      if (id === this.value) return
      this.$emit('change', id, name)
    },
    onChangeMarketBar(id, name) {
      if (id !== this.value) {
        this.updateTempMarket(id, name)
        this.$emit('change', id, name)
      }
      this.hideMarketBar()
    },
    showMarketBar() {
      this.marketVisible = true
      this.$el.classList.add('higher')
      modalHelper.afterOpen()
      window.mstrace(this.dataLabel)
    },
    hideMarketBar() {
      modalHelper.beforeClose()
      this.$el.classList.remove('higher')
      this.marketVisible = false
    },
    updateTempMarket(id, name) {
      const marketId = id || this.value
      if (this.marketList.some(({ id }) => id === marketId)) return
      if (id) {
        this.tempMarket = { id, name }
      } else {
        for (let i = this.marketGroupList.length; i--; ) {
          const [, list] = this.marketGroupList[i]
          const market = list.find(({ id }) => id === marketId)
          if (market) {
            this.tempMarket = market
            break
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m {
  &-more {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    width: 36px;
    height: 50px;
    align-items: center;
    margin: auto;
    background: #000;
    box-shadow: -16px 0 26px #000;

    img {
      display: block;
      margin-left: 7px;
    }
  }

  &-market-navs {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;

    &.sticky {
      position: sticky;
      z-index: 1000;
      background: #000;
    }

    // ::v-deep .icon.icon-close {
    //   fill: white;
    // }
    ::v-deep .popup-wrap .close-btn {
      top: 11px;
      right: 16px;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: #222;

      .icon-close {
        width: 14px;
        fill: #fff;
      }
    }

    .m-sub-navs {
      width: 100%;
      padding: 12px 0;
      background: black;
      font-size: 14px;

      &.active {
        color: white;
      }

      .m-sub-nav-item {
        height: 26px;
        padding: 0 8px;
        border-radius: 13px;
        margin-right: 8px;
        background: #333;
        color: #d8d8d8;
        cursor: pointer;
        font-size: 12px;
        line-height: 26px;

        ::v-deep .item-label {
          display: inline-block;
          min-width: 40px;
        }

        &.active {
          background: #ffe74f linear-gradient(315deg, #ffe74f 0%, #ffad31 100%);
          color: #000;
          font-weight: 700;
        }

        &:first-child {
          margin-left: 20px;
        }

        &:last-child {
          margin-right: 20px;
        }
      }

    }

    &.has-more {
      padding-right: 36px;
    }
  }
}

[data-mode='light'] {
  .m-market-navs {
    &.sticky {
      background: #fff;
    }

    .m-sub-navs {
      background: #fff;
      color: #000;

      .m-sub-nav-item {
        background: #fff;
        color: #666;

        &.active {
          background: #ffca27;
          color: #1b1b1b;
        }
      }
    }

    ::v-deep .popup-wrap .close-btn {
      background: #fff;

      .icon-close {
        fill: #666;
      }
    }
  }
}
</style>

<style>
.higher {
  z-index: 2100 !important;
}
</style>
